import { Component, Input } from '@angular/core';
import { ShareMailService } from './share-mail.service';
import { Router } from '@angular/router';
import { first } from 'rxjs';

@Component({
  selector: 'app-share-mail',
  templateUrl: './share-mail.component.html',
  styleUrls: ['./share-mail.component.scss'],
})
export class ShareMailComponent {
  @Input() bien: any;

  constructor(
    private shareMailService: ShareMailService,
    private router: Router
  ) {}

  launchedRequest = false;
  showSendMail = false;

  formShareFriend: any = {
    lastname: '',
    email: '',
    email1: '',
    email2: '',
    email3: '',
    messsage: '',
  };

  SendShareFriend(param?: any, id?: any) {
    this.shareMailService
      .shareByMail(id, param)
      .pipe(first())
      .subscribe((response:any) => {
        if(response?.status === 'OK'){
          this.showSendMail = true;
        }
      });
  }

  onSendShareFriend(blockProperty: any) {
    if (this.launchedRequest == false) {
      this.launchedRequest = true;
      this.SendShareFriend(
        this.formShareFriend,
        blockProperty.id ? blockProperty.id : blockProperty.property.id
      );
    }
  }
}
